import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import bosLocales from './locales/bos/bos.json';

function buildResources(locales) {
  const fr = {};
  const en = {};
  for (const [key, val] of Object.entries(locales)) {
    fr[key] = val?.fr ?? '';
    en[key] = val?.en ?? '';
  }
  return {
    fr: { translation: fr },
    en: { translation: en },
  };
}

let initialized = false;

const initI18n = () => {
  if (!initialized) {
    i18next
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources: buildResources(bosLocales),
        fallbackLng: 'fr',
        ns: ['translation'],
        defaultNS: 'translation',
        supportedLngs: ['en', 'fr'],
        detection: {
          order: ['localStorage', 'navigator'],
          caches: ['localStorage'],
        },
        load: 'languageOnly',
      });

    initialized = true;
  }
};

const resetInitialized = () => {
  initialized = false;
};

export { resetInitialized };
export default initI18n;
